import Scenes from "oc-threejs/Scenes";
import Jaco3d from "./Jaco3d";
import Commons from "oc-commons/Commons";

export default class Model3d extends Jaco3d {

    isModel3d = true;

    /** @type {?THREE.Group} */
    group;
    /** @type {?THREE.Group} */
    originalGroup;
    changeId = Math.random();
    /** @type {?THREE.Mesh} */
    _clippingMesh;

    static getClippingMaterial = Commons.cacheIdentity(() => new THREE.MeshBasicMaterial({
        // für Debug-Zwecke ist eine Anzeige praktisch
        color: 0x000000,
        wireframe: true,
        transparent: true,
        opacity: 0.5
    }));

    /** */
    update3d() {
        super.update3d();
        // Vorteil, das Clipping direkt im Model3d zu machen: das Model verändert seine Matrix nicht.
        // Daher sind die einzigen Events, die ein Re-Clipping erfordern, Model-Load und Clipping-Parameters
        if (this.changed('clippingParameters') || this.changed('clipping')) {
            this.updateClippingMesh();
            if (!this.changed('key')) {
                this.clipModel();
            }
        }
        if (this.changed('key')) {
            if (this.group != null) {
                Scenes.remove(this.group);
            }
            const meta = this.jaco.getMeta();
            this.originalGroup = this.group = this.loadObject3DByModel(meta, () => this.onLoadModel());
            this.group.name = this.jaco.key;
            this.add(this.group);
            this.dirty();
        } else if (this.changed('materialMap')) {
            this.updateMaterialMap();
        }
    }

    /** */
    updateMaterialMap() {
        const meta = this.jaco.getMeta();
        const materialsFactory = this.getMaterialFactory(meta);
        const swap = m => {
            const materialNameToSwap = m.userData.originalName ?? m.name;
            return materialsFactory.create(materialNameToSwap);
        };
        Scenes.filter(this.group, o => o.material!=null).forEach(o => {
            if (Array.isArray(o.material)){
                o.material=o.material.map(swap);
            } else {
                o.material = swap(o.material);
            }
        });
    }

    /** */
    onLoadModel() {
        this.updateClippingMesh();
        this.clipModel();
        this.dirty();
    }

    /** */
    updateClippingMesh() {
        if (this.jaco.clippingParameters == null || Commons.isEqualEpsilon(this.jaco.defaultClippingParameters, this.jaco.clippingParameters)) {
            return;
        }
        if (this._clippingMesh != null) {
            Scenes.remove(this._clippingMesh);
        }
        const geometry = this.jaco.getClippingGeometry();
        const material = Model3d.getClippingMaterial();
        this._clippingMesh = new THREE.Mesh(geometry, material);

        // für Debug-Zwecke visible auf true setzen
        this._clippingMesh.visible = false;

        this.add(this._clippingMesh);
    }

    /** */
    clipModel() {
        if (this.jaco.clippingParameters == null
            || Commons.isEqualEpsilon(this.jaco.defaultClippingParameters, this.jaco.clippingParameters)) {
            return;
        }
        if (this.group != null) {
            Scenes.remove(this.group);
        }
        this.group = this.originalGroup.clone();
        this.add(this.group);
        this.group.updateMatrixWorld(true);
        if (this.jaco.clipping) {
            this.jaco.clippingFunction(this.group, this._clippingMesh);
        }

        if (STAGE.settings.showDebugObjects) {
            if (this._debugInfo != null) {
                Scenes.remove(this._debugInfo);
            }
            this._debugInfo = new THREE.Group();
            this._debugInfo.add(Debugs.box(this.jaco.getBox(), 0xff0000, true));
            const clippingClone = this._clippingMesh.clone();
            clippingClone.visible = true;
            this._debugInfo.add(clippingClone);
            this.group.add(this._debugInfo);
        }

        this.dirty();
    }

    /** */
    dirty() {
        this.changeId++;
        STAGE.dirty();
    }

}
